import { evidenceIndex } from '../../AboutHelpers.tsx';
import { FormulaAccordion } from './components/FormulaAccordion';

function EvidenceIndexVisual() {
  const scenarios = [
    {
      label: 'All publications support the association',
      supporting: 1.0,
      contradictory: 0,
      ei: 1.0,
      eiColor: '#047857',
      trackColor: '#10B981',
    },
    {
      label: 'Some publications report no association',
      supporting: 0.7,
      contradictory: 0.3,
      ei: 0.7,
      eiColor: '#B45309',
      trackColor: '#F59E0B',
    },
  ];

  return (
    <div className="my-4 space-y-3">
      {scenarios.map((s, idx) => (
        <div key={idx} className="rounded-md border border-gray-200 bg-gray-50 px-4 py-3">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs text-gray-600">{s.label}</span>
            <span
              className="text-xs font-bold tabular-nums px-2 py-0.5 rounded"
              style={{ backgroundColor: s.eiColor, color: '#fff' }}
            >
              EI = {s.ei.toFixed(1)}
            </span>
          </div>
          {/* Stacked bar: supporting vs contradictory */}
          <div className="flex h-5 rounded overflow-hidden border border-gray-200">
            <div
              className="flex items-center justify-center h-full transition-all"
              style={{ width: `${s.supporting * 100}%`, backgroundColor: s.trackColor }}
            >
              {s.supporting > 0.15 && (
                <span className="text-white text-[10px] font-semibold select-none">
                  {Math.round(s.supporting * 100)}% supporting
                </span>
              )}
            </div>
            {s.contradictory > 0 && (
              <div
                className="flex items-center justify-center h-full"
                style={{ width: `${s.contradictory * 100}%`, backgroundColor: '#E5E7EB' }}
              >
                <span className="text-gray-500 text-[10px] font-semibold select-none">
                  {Math.round(s.contradictory * 100)}% contradictory
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function AboutMetricsEvidenceIndex(): React.ReactElement {
  return (
    <div id="evindex">
      <h3>Evidence Index</h3>
      <p>
        The Evidence Index (EI) indicates the existence of contradictory results in publications supporting a
        gene/variant–disease association. It is computed for text mining and PsyGeNET associations. EI = 1
        means all publications support the association; EI &lt; 1 indicates contradictory evidence.
      </p>
      <EvidenceIndexVisual />
      <p className="text-sm text-gray-500">
        If the gene/variant has no EI value, the index has not been computed for that association.
      </p>
      <FormulaAccordion label="View formula">
        <span>{evidenceIndex()}</span>
        <div className="mt-3 text-sm text-gray-600">
          <dt className="font-medium">where:</dt>
          <ul className="mt-1 space-y-1">
            <li>
              N<sub>pubs+</sub> — number of publications supporting the association
            </li>
            <li>
              N<sub>pubs total</sub> — total number of publications
            </li>
          </ul>
        </div>
      </FormulaAccordion>
    </div>
  );
}

export default AboutMetricsEvidenceIndex;
